"use client"

import { Translate } from "@/components/translate"
import { Button } from "@/components/ui/button"
import { useConfigParams } from "@/hooks/use-config-params"
import { trackAnalyticsEvent } from "@/lib/analytics"

export function RegisterButton() {
  const { channel, authType } = useConfigParams()

  const handleClick = () => {
    trackAnalyticsEvent({
      event: "link_click",
      event_name: "nav_click",
      conversion_pagename: "login",
      position: "login",
      cta_label: "registrati",
    })

    const url = buildRegistrationUrl(authType, channel)

    window.location.href = url.toString()
  }

  return (
    <Button
      className="bg-paper mb-8 border-(--btn-secondary-outlined-border)"
      variant="outline"
      onClick={handleClick}
    >
      <Translate i18nKey="LoginPage.signupCta" />
    </Button>
  )
}
function buildRegistrationUrl(authType: string, channel: number) {
  const url = new URL("/registrazioneJwt", window.location.origin)
  const searchParams = new URLSearchParams()
  searchParams.set("auth-type", authType)
  searchParams.set("siteid", channel.toString())
  url.search = searchParams.toString()
  return url
}
